// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class GeneralDetailDto {
    @AutoMap() value1: string;
    @AutoMap() value2: string;
    @AutoMap() value3: string;
    @AutoMap() value4: string;
}